module.exports = __webpack_public_path__ + "static/img/qiche.8e1e3327.svg";